var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content",staticStyle:{"margin":"0px","width":"100%"}},[(_vm.is_self_route)?_c('v-container',{attrs:{"fluid":""}},[_c('EventsList')],1):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }